/**
 * LeaderboardTableHeader – column header row for the group leaderboard table.
 */

import React from 'react';
import { View } from 'react-native';
import { Image } from 'expo-image';
import { User, Gamepad2, Trophy } from 'lucide-react-native';
import {
  TABLE_HEADER_ICON_SIZE,
  getGroupLeaderboardStyles,
} from '../../../appStyles/_groupLeaderboard.styles';
import { GROUP_LEADERBOARD_HEADER_TOOLTIPS } from '../../../constants/tooltips';
import { InfoTooltip } from '../../../src/shared/components/InfoTooltip';
import { IDLE_COIN_SOURCE } from '../../../constants/assets';
import { WEB_IMAGE_ALT_DECORATIVE } from '../../../src/shared/helpers/imageWebAlt.helper';

export interface LeaderboardTableHeaderProps {
  styles: ReturnType<typeof getGroupLeaderboardStyles>;
  iconColor: string;
}

export const LeaderboardTableHeader: React.FC<LeaderboardTableHeaderProps> = ({ styles, iconColor }) => (
  <View style={styles.tableHeader}>
    <View style={styles.tableHeaderRank} />
    <View style={styles.tableHeaderAvatar} />
    <View style={styles.tableHeaderName} accessibilityLabel="Player">
      <User size={TABLE_HEADER_ICON_SIZE} color={iconColor} style={styles.tableHeaderNameIcon} />
    </View>
    <View style={styles.tableHeaderStatFirst}>
      <InfoTooltip content={GROUP_LEADERBOARD_HEADER_TOOLTIPS.GAMES} accessibilityLabel="What are games?"
        trigger={<Gamepad2 size={TABLE_HEADER_ICON_SIZE} color={iconColor} />}
      />
    </View>
    <View style={styles.tableHeaderStat}>
      <InfoTooltip content={GROUP_LEADERBOARD_HEADER_TOOLTIPS.WINS} accessibilityLabel="What are wins?"
        trigger={<Trophy size={TABLE_HEADER_ICON_SIZE} color={iconColor} />}
      />
    </View>
    <View style={styles.tableHeaderPts}>
      <InfoTooltip content={GROUP_LEADERBOARD_HEADER_TOOLTIPS.COINS} accessibilityLabel="What are coins?"
        trigger={
          <Image source={IDLE_COIN_SOURCE} style={styles.tableHeaderCoinIcon} alt={WEB_IMAGE_ALT_DECORATIVE} />
        }
      />
    </View>
  </View>
);
